import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

const Dropdown = ({ className, items, onItemSelect, isOpenInitially, activeItemIndex }) => {
  const [isOpen, setIsOpen] = useState(isOpenInitially || false);
  const [activeItem, setActiveItem] = useState(items[activeItemIndex] || items[0]);

  const toggleDropdown = useCallback(() => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  }, []);

  const handleItemSelect = useCallback((item) => {
    setActiveItem(item); // Update the active item
    onItemSelect(item);
    setIsOpen(false);    // Close the dropdown upon selecting an item
  }, [onItemSelect]);

  const baseClass = className || 'ui-select';
  const activeClass = isOpen ? `${baseClass}--opened` : '';

  return (
    <div className="dropdown">
      <div className={`${baseClass} ${activeClass}`}>
        <div className={`${baseClass}__input`} onClick={toggleDropdown}>
          <span className={`${baseClass}__input-label`}/>
          <span className={`${baseClass}__input-value`}>{activeItem.label}</span>
        </div>
        <div className={baseClass + "__dropdown"}>
          {isOpen && (
            <ul className={`${baseClass}__dropdown-list`} style={{ maxHeight: '300px', overflow: 'auto' }}>
              {items.map((item, index) => {
                const isActive = item.value === activeItem.value;

                return (
                  <li key={index}
                      onClick={() => handleItemSelect(item)}
                      className={`${baseClass}__dropdown-list-item`
                      + (isActive ? ` ${baseClass}__dropdown-list-item--active` : "")}>
                    {item.label}
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,
  onItemSelect: PropTypes.func.isRequired,
  isOpenInitially: PropTypes.bool,
  activeItemIndex: PropTypes.number // Index of the initially active item
};

Dropdown.defaultProps = {
  activeItemIndex: 0 // Default to the first item if no active item is specified
};

export default Dropdown;
